/* =========================================================
   Heatronics - PDP trust badges as a horizontal marquee.

   CSS alone cannot do a seamless loop: one copy of the
   badges leaves a blank stretch between the tail going out
   and the head coming back. So this repeats the badge set
   until the track is at least one full set wider than the
   visible strip, then slides it by exactly one set's width.
   When the animation restarts, a copy is sitting precisely
   where the original was, so the seam is invisible AND the
   strip is never short of content at the right-hand edge.

     sets needed = 1 + ceil(strip width / set width)

   With the hCore badges that is 331px per set in a 358px
   strip on a phone and a 503px strip on desktop: three sets
   either way.

   The repeats are aria-hidden, so a screen reader still
   reads "45% Price Drop, ISO Certified, BIS Certified" once.

   Speed is constant (PX_PER_SEC), not a fixed duration, so
   adding or renaming a badge does not change how fast the
   strip moves - the cycle time is recalculated from the
   measured width.

   Styling lives in assets/badge-rotator.css. Remove the
   <script> line in snippets/stylesheets.liquid to switch
   this off; the badges fall back to a plain row.
   ========================================================= */

(function () {
  var SEL = '[class*="ai-product-badges__container-"]';
  var GAP = 8;            // px between badges, matches the CSS
  var PX_PER_SEC = 42;    // scroll speed
  var MAX_SETS = 8;       // sanity cap

  function setWidth(track, setSize) {
    var width = 0;
    for (var i = 0; i < setSize; i++) {
      var kid = track.children[i];
      if (kid) width += kid.getBoundingClientRect().width + GAP;
    }
    return width;
  }

  function addSet(track, originals) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < originals.length; i++) {
      var copy = originals[i].cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      frag.appendChild(copy);
    }
    track.appendChild(frag);
  }

  /* Keep enough repeats that the strip is always full, and publish the
     one-set shift and the matching cycle time for the CSS keyframe. */
  function sync(cont, track, originals) {
    var size = originals.length;
    var width = setWidth(track, size);
    if (width <= 0) return;

    var visible = cont.getBoundingClientRect().width;
    var wanted = 1 + Math.ceil(visible / width);
    if (wanted > MAX_SETS) wanted = MAX_SETS;

    var have = Math.round(track.children.length / size);
    while (have < wanted) {
      addSet(track, originals);
      have++;
    }

    cont.style.setProperty('--hb-shift', width.toFixed(2) + 'px');
    cont.style.setProperty('--hb-cycle', (width / PX_PER_SEC).toFixed(2) + 's');
  }

  var registry = [];

  function build(cont) {
    if (cont.getAttribute('data-hb-marquee') === '1') return;

    var originals = [];
    for (var i = 0; i < cont.children.length; i++) originals.push(cont.children[i]);
    if (originals.length < 2) return;

    cont.setAttribute('data-hb-marquee', '1');

    var track = document.createElement('div');
    track.className = 'hb-track';
    for (var j = 0; j < originals.length; j++) track.appendChild(originals[j]);
    cont.appendChild(track);

    registry.push({ cont: cont, track: track, originals: originals.slice() });
    sync(cont, track, originals);
  }

  var queued = false;
  function scan() {
    queued = false;
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) build(list[i]);
  }
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  function resync() {
    registry = registry.filter(function (entry) {
      return entry.cont.isConnected;
    });
    registry.forEach(function (entry) {
      sync(entry.cont, entry.track, entry.originals);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* The buy box is re-rendered by the Section Rendering API on every
     variant change, which replaces the container with a fresh one. */
  document.addEventListener('shopify:section:load', queueScan);
  if (window.MutationObserver) {
    new MutationObserver(queueScan).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  window.addEventListener('resize', resync);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(resync);
  }
})();
